import React from "react";
import { Heart, Coffee, ChefHat, Sparkles } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const features = [{
  title: "Teljeskörű Biztosítás",
  description: "Minden foglalásunkhoz prémium utasbiztosítási opciókat kínálunk, hogy Ön csak a pihenésre koncentrálhasson.",
  icon: Heart
}, {
  title: "24/7 Támogatás",
  description: "Szakértő csapatunk a nap 24 órájában rendelkezésre áll, legyen szó járattörlésről vagy váratlan helyzetekről.",
  icon: Coffee
}, {
  title: "Hivatalos Partnerek",
  description: "Kizárólag ellenőrzött légitársaságokkal és szálláshelyekkel dolgozunk, garantálva a nemzetközi sztenderdeket.",
  icon: ChefHat
}, {
  title: "Biztonságos Fizetés",
  description: "A legmodernebb titkosítási technológiákat alkalmazzuk, így tranzakciói és adatai nálunk teljes biztonságban vannak.",
  icon: Sparkles
}];
export default function WhyHabeshaPastry() {
  return <section data-section-id="223936" id="biztonságos-utazás" className="relative py-24 md:py-32 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="text-[25rem] md:text-[40rem] font-serif leading-none text-primary/5">
          T
        </span>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-secondary mb-4">
            Biztonságos Utazás
          </h2>
          <p className="text-lg text-muted-foreground font-serif">
            Az Ön nyugalma a mi prioritásunk. Fedezze fel, hogyan tesszük gondtalanná minden egyes kilométerét.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className="bg-card/80 backdrop-blur-md border-border shadow-lg hover:shadow-xl transition-all duration-300 group rounded-3xl">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                    <Icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-default font-bold text-xl text-secondary">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed font-default">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}